import { Users, Building2, Heart } from "lucide-react";
import { Reveal, ChapterHead } from "./Reveal";

export default function Mecanisme() {
  return (
    <section id="mecanisme" data-testid="section-mecanisme" className="relative py-28 md:py-36 overflow-hidden" style={{ background: "linear-gradient(180deg, rgba(255,142,83,0.22), rgba(255,42,122,0.15))" }}>
      <div className="orb w-[500px] h-[500px] bg-[#FF2A7A] blur-[140px] opacity-25 top-20 right-[-10%]" aria-hidden="true" />
      <div className="orb w-[380px] h-[380px] bg-[#FFB347] blur-[120px] opacity-30 bottom-0 left-[-8%]" aria-hidden="true" />

      <div className="wrap relative">
        <ChapterHead
          num="02"
          badge="Le mécanisme"
          title={<>Créer la <span className="font-serifit italic font-normal text-[#E8431F]">synergie</span> qui change tout</>}
          note="Comme une place de marché : chaque côté profite d'un système pensé pour l'autre."
        />

        {/* Diagramme synergie */}
        <div className="grid lg:grid-cols-[1fr_auto_1fr] items-center gap-8">
          {/* Hub au centre, en premier sur mobile */}
          <Reveal delay={0.1} className="order-1 lg:order-none lg:col-start-2">
            <div
              data-testid="flow-hub"
              className="pulse-soft relative mx-auto flex items-center justify-center w-[230px] h-[230px] md:w-[310px] md:h-[310px] rounded-full bg-gradient-to-br from-[#E8431F] to-[#D6478E] text-[#FFF6EE] text-center shadow-[0_50px_100px_-40px_rgba(214,71,142,0.55)]"
            >
              <span className="absolute inset-3 rounded-full border border-white/25" aria-hidden="true" />
              <p className="font-display font-bold text-2xl md:text-3xl leading-tight px-8">
                Douceur Power <span className="font-serifit italic font-normal">Prod</span>
              </p>
            </div>
          </Reveal>

          <div className="order-2 lg:hidden h-10 w-px bg-[#33181F]/25 mx-auto" aria-hidden="true" />

          <div className="order-3 lg:order-none lg:col-start-1 lg:row-start-1 flex flex-col items-center lg:items-stretch gap-8 lg:gap-24">
            <Reveal>
              <div data-testid="flow-node-pros" className="flex flex-col lg:flex-row items-center gap-4 lg:gap-5 text-center lg:text-left">
                <span className="flex items-center justify-center w-12 h-12 rounded-full bg-[#E8431F]/10 text-[#E8431F] shrink-0"><Users size={20} strokeWidth={1.6} /></span>
                <h3 className="font-display font-semibold text-xl md:text-2xl leading-tight max-w-[16ch]">Réseau de professionnels du bien-être</h3>
                <span className="hidden lg:block h-px flex-1 bg-[#33181F]/20" />
              </div>
            </Reveal>
            <div className="lg:hidden h-8 w-px bg-[#33181F]/20" aria-hidden="true" />
            <Reveal delay={0.05}>
              <div data-testid="flow-node-public" className="flex flex-col lg:flex-row items-center gap-4 lg:gap-5 text-center lg:text-left">
                <span className="flex items-center justify-center w-12 h-12 rounded-full bg-[#E8431F]/10 text-[#E8431F] shrink-0"><Heart size={20} strokeWidth={1.6} /></span>
                <h3 className="font-display font-semibold text-xl md:text-2xl leading-tight max-w-[16ch]">Un public qui recherche l'expérience wellness</h3>
                <span className="hidden lg:block h-px flex-1 bg-[#33181F]/20" />
              </div>
            </Reveal>
          </div>

          <div className="order-4 lg:hidden h-10 w-px bg-[#33181F]/25 mx-auto" aria-hidden="true" />

          <div className="order-5 lg:order-none lg:col-start-3 lg:row-start-1 flex flex-col items-center lg:items-stretch gap-12 lg:gap-24">
            <Reveal delay={0.1}>
              <div data-testid="flow-node-lieux" className="flex flex-col lg:flex-row-reverse items-center gap-4 lg:gap-5 text-center lg:text-right">
                <span className="flex items-center justify-center w-12 h-12 rounded-full bg-[#E8431F]/10 text-[#E8431F] shrink-0"><Building2 size={20} strokeWidth={1.6} /></span>
                <h3 className="font-display font-semibold text-xl md:text-2xl leading-tight">Lieux</h3>
                <span className="hidden lg:block h-px flex-1 bg-[#33181F]/20" />
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal className="mt-12 text-center">
          <p data-testid="flow-tagline" className="font-serifit italic text-2xl md:text-3xl text-[#5F5258]">
            Un maximum de créneaux remplis et d'opportunités
          </p>
          <span data-testid="flow-no-invest" className="mt-6 inline-block eyebrow border border-[#E8431F]/40 text-[#E8431F] rounded-full px-6 py-3 !text-[0.62rem]">
            Sans investissement initial
          </span>
        </Reveal>
      </div>
    </section>
  );
}
